import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import api from '../lib/api';
import { Button } from '../components/ui/button';

export default function PaymentResult() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');
  const isCancel = window.location.pathname.includes('annullato');
  const [status, setStatus] = useState(isCancel ? 'cancelled' : 'polling');
  const attempts = useRef(0);

  useEffect(() => {
    if (isCancel || !sessionId) return;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') { setStatus('paid'); return; }
      } catch { /* retry */ }
      attempts.current += 1;
      if (attempts.current < 12) setTimeout(poll, 2000);
      else setStatus('timeout');
    };
    poll();
  }, [sessionId, isCancel]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-result">
      {status === 'polling' && (
        <>
          <Loader2 className="mx-auto text-brand animate-spin mb-5" size={44} strokeWidth={1.5} />
          <h1 className="font-display text-2xl font-semibold text-slate-900 mb-2">Verifica del pagamento...</h1>
          <p className="text-slate-500">Stiamo confermando il tuo acquisto, pochi secondi.</p>
        </>
      )}
      {status === 'paid' && (
        <>
          <CheckCircle2 className="mx-auto text-emerald-600 mb-5" size={52} strokeWidth={1.5} />
          <h1 className="font-display text-2xl sm:text-3xl font-semibold text-slate-900 mb-2" data-testid="payment-success-title">Acquisto completato!</h1>
          <p className="text-slate-500 mb-8">Il pacchetto è ora disponibile nella tua libreria personale.</p>
          <Button onClick={() => navigate('/area-personale')} data-testid="payment-goto-library"
            className="rounded-full bg-brand hover:bg-brand-hover text-white px-8 h-12">
            Vai alla mia libreria
          </Button>
        </>
      )}
      {(status === 'cancelled' || status === 'timeout') && (
        <>
          <XCircle className="mx-auto text-slate-300 mb-5" size={52} strokeWidth={1.5} />
          <h1 className="font-display text-2xl font-semibold text-slate-900 mb-2">
            {status === 'cancelled' ? 'Pagamento annullato' : 'Verifica in ritardo'}
          </h1>
          <p className="text-slate-500 mb-8">
            {status === 'cancelled'
              ? 'Nessun addebito effettuato. Puoi riprovare quando vuoi.'
              : 'Se il pagamento è andato a buon fine, il pacchetto apparirà a breve nella tua libreria.'}
          </p>
          <Button onClick={() => navigate('/concorsi')} variant="outline" data-testid="payment-back-catalog" className="rounded-full px-8 h-12">
            Torna al catalogo
          </Button>
        </>
      )}
    </div>
  );
}
